import {useQuery} from 'react-query'

import {PartyLedgerEditModalForm} from './PartyLedgerEditModalForm'
import {getPartyLedgerById} from '../core/_requests'
import {isNotEmpty, QUERIES} from '../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'

const PartyLedgerEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()

  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: message,
    error,
  } = useQuery(
    `${QUERIES.SERVICECENTERS_LIST}-partyledger-${itemIdForUpdate}`,
    () => {
      return []
      return getPartyLedgerById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return <PartyLedgerEditModalForm isMessageLoading={isLoading} message={{id: undefined}} />
  }

  if (!isLoading && !error && message) {
    return <PartyLedgerEditModalForm isMessageLoading={isLoading} message={{id: message}} />
  }

  return null
}

export {PartyLedgerEditModalFormWrapper}
